module.exports = __webpack_public_path__ + "img/es-box4-text-dark.43aa32f8.png";